import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subscription } from 'rxjs';
import { DescriptorOption } from '../../descriptor/descriptor-option';
import { LovService } from '../../services/lov.service';
import { VedraxBaseComponent } from '../vedrax-base.component';

@Component({
  selector: 'vedrax-select-autocomplete',
  templateUrl: './vedrax-select-autocomplete.component.html',
  styleUrls: ['./vedrax-select-autocomplete.component.scss']
})
export class VedraxSelectAutocompleteComponent extends VedraxBaseComponent implements OnInit, AfterViewInit, OnDestroy {

  private subscription: Subscription = new Subscription();

  /**
 * Emit number of options when all of them are available
 */
  @Output() isReady: EventEmitter<number> = new EventEmitter();

  /** control for the MatSelect filter keyword */
  public filterCtrl: FormControl = new FormControl();

  /** list of options filtered by search keyword */
  public filteredOptions: ReplaySubject<DescriptorOption[]> = new ReplaySubject<DescriptorOption[]>(1);

  /**
   * The select component reference
   */
  private selectComponent?: MatSelect;

  placeholderLabel: string = "Rechercher";

  noEntriesFoundLabel: string = "Recherche introuvable...";

  /**
   * The Select reference setter
   */
  @ViewChild(MatSelect) set singleSelect(matSelect: MatSelect) {
    this.selectComponent = matSelect;
  }

  constructor(private lovService: LovService) {
    super();
  }

  options: DescriptorOption[] = [];

  ngOnInit() {
    this.subscription.add(this.lovService.getOptionsFromControlDescriptor(this.descriptor)
      .subscribe(options => {
        this.options = options;
        //emit nb of options
        this.isReady.emit(options.length);
        //inform all compoment of availability of options
        if (!this.descriptor.controlOptions) {
          this.descriptor.controlOptions = options;
        }
        // load the initial bank list
        this.filteredOptions.next(this.options.slice());
      }));

    // listen for search field value changes
    this.subscription.add(this.filterCtrl.valueChanges
      .subscribe(() => {
        this.filterOptions();
      }));
  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Sets the initial value after the filteredOptions are loaded initially
   */
  protected setInitialValue() {
    this.subscription.add(this.filteredOptions
      .subscribe(() => {
        if (this.selectComponent) {
          this.selectComponent.compareWith = (a: any, b: any) => a === b;
        }
      }));
  }

  protected filterOptions() {
    if (!this.options) {
      return;
    }
    // get the search keyword
    let search = this.filterCtrl.value;
    if (!search) {
      this.filteredOptions.next(this.options.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the options
    this.filteredOptions.next(
      this.options.filter(item => item.value.toLowerCase().indexOf(search) > -1)
    );
  }

}
